import React from "react";
import { TYPE_PC } from "../../common/defines";
import { breadcrumbs } from "../../common/breadcrumbs";
import { ResultList } from "../area/ResultList";
import { MapControl } from "../area/MapControl";
import { Area } from "../area/Area";
import { SearchCondition } from "../area/SearchCondition";
import PropTypes from "prop-types";
import classnames from "classnames";
import Accordion from "semantic-ui-react/dist/commonjs/modules/Accordion";
import { conditionString } from "../../lib/masterUtil";

export class AreaMap extends Area {
  static contextTypes = {
    router: PropTypes.object,
  };
  toggleSearch = () => {
    this.setState({
      activeIndex: this.state.activeIndex ? null : 1,
    });
  };
  getScrollTarget() {
    // 検索後は、同一コンポネントの地図ページなので、トップにスクロールする
    return this;
  }
  componentDidMount() {

  }
  /* eslint-disable complexity */
  render() {
    const type = this.props.type;
    const condition = (this.state.value && this.state.value.condition) || {};
    const pref = condition.pref ? masterData.pref.byId[condition.pref] : null;
    const city =
      pref && condition.city && condition.city.length === 1
        ? masterData.city.byPrefAndSlug[pref.prefId][condition.city[0]]
        : null;
    const line = condition.line ? masterData.line.bySlug[condition.line[0]] : null;
    const station = condition.station ? masterData.station.byId[condition.station[0]] : null;


    // 路線名
    const parts = [];
    if (condition.line) {
      parts.push(
        condition.line.map((l) => {
          return masterData.line.bySlug[l].name
        })
        .join("・")
      );
    }
    // 駅名
    if (condition.station) {
      parts.push(
        condition.station.map((stationId) => {
          return masterData.station.byId[stationId] && masterData.station.byId[stationId].name + '駅'
        })
        .join("・")
      );
    }

    if (city) {
      // document.title = `${pref && pref.name} ${city.name}/トランクルームをお探しなら『ハローストレージ』【公式】`;
    } else if (station && line) {
      // document.title = `${line && line.name} ${station && station.name}/トランクルームをお探しなら『ハローストレージ』【公式】`;
    } else if (line) {
      // document.title = `${line && line.name}/トランクルームをお探しなら『ハローストレージ』【公式】`;
    }

    let baseCity = null;
    if (pref && city && city.districtSlug) {
      baseCity = masterData.city.byPrefAndSlug[pref.prefId][city.baseSlug];
    }

    return (
      <div className="container">
        {(() => {
          if (pref) {
            return breadcrumbs(
              type,
              [
                {
                  href: `/${pref && pref.slug}/list/`,
                  text: pref.name,
                },
                baseCity && {
                  href: `/${pref && pref.slug}/${baseCity.slug}/`,
                  text: baseCity.name,
                },
                city && baseCity && {
                  href: `/${pref && pref.slug}/${baseCity.slug}/${city.districtSlug}/`,
                  text: city.districtName,
                },
                city && !baseCity && {
                  href: `/${pref && pref.slug}/${city.slug}/`,
                  text: city.name,
                },
                line && pref && {
                  href: `/${pref && pref.slug}/line-${line.slug}/`,
                  text: line.name,
                },
                line && station && pref && {
                  href: `/${pref && pref.slug}/line-${line.slug}/${station.slug}/`,
                  text: station.name + '駅',
                },
                line && !pref && {
                  href: `/line-${line.slug}/`,
                  text: line.name,
                },
                station && !pref && {
                  href: `/line-${line.slug}/${station.slug}/`,
                  text: station.name + '駅',
                },
                this.props.history.location.search && {
                  text: "検索結果",
                },
              ].filter(item => item)
            );
          } else if (line) {
            return breadcrumbs(
              type,
              [
                {
                  href: `/line-${line.slug}/`,
                  text: line.name,
                },
                station && {
                  href: `/line-${line.slug}/${station.slug}/`,
                  text: station.name + '駅',
                },
              ].filter(item => item)
            );
          }
        })()}
        <div className="content">
          <div className="control">
            <div className="title">
              {(() => {
                if (station) {
                  return (
                    <h1>
                      <span>
                        <span className="area_name">
                          {parts}
                        </span>
                        のトランクルームを探す
                      </span>
                    </h1>
                  );
                } else if (line) {
                  return (
                    <h1>
                      <span>
                        <span className="area_name">
                          {parts}
                        </span>
                        のトランクルームを探す
                      </span>
                    </h1>
                  );
                } else if (pref) {
                  return (
                    <h1>
                      <span>
                        <span className="area_name">
                          {pref.name}
                          {city ? city.name : ""}
                        </span>
                        のトランクルームを探す
                      </span>
                    </h1>
                  );
                }
              })()}
            </div>
            <div
              className={classnames({
                hide: !this.state.list || !this.state.list.length,
              })}
            >
            {(() => {
              if (this.props.type == TYPE_PC) {
                return (
                  <MapControl
                    list={this.state.list}
                    history={this.context.router.history}
                    type={this.props.type}
                    isDetail={false}
                  />
                )
              }
            })()}
            </div>
            <div
              className={classnames({
                hide: this.state.list && this.state.list.length,
              })}
            >
              該当する物件はありませんでした。条件を変更して検索してください。
            </div>
            <div className="search_cont">
              <Accordion>
                <Accordion.Title
                  active={this.state.activeIndex === 1}
                  index={1}
                  onClick={this.toggleSearch}
                >
                  <div className="serach_header">
                    <div className="title">検索条件</div>
                    <div className="conditions">
                      {conditionString(
                        this.state.value,
                        pref && pref.prefId
                      )}
                    </div>
                    <div className="btn">条件を変更する</div>
                  </div>
                </Accordion.Title>
                <Accordion.Content active={this.state.activeIndex === 1}>
                  <div className="search_cont_dtl">
                    <SearchCondition
                      {...this.props}
                      value={this.state.value && this.state.value.condition}
                      onSearch={value => {
                        this.onClickSearchButton({ condition: value });
                      }}
                    />
                  </div>
                </Accordion.Content>
              </Accordion>
            </div>
          </div>
          <div ref="searchResult" />
          <ResultList
            {...{
              type,
              list: this.state.list,
              resetScroll: this.resetScroll,
              condition: this.state.value.condition,
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area_map/AreaMap.jsx